export enum RestrictionEnum {
  WCL = 'WCL',
  L = 'L',
  Z = 'Z',
  E = 'E',
  X = 'X',
  O = 'O',
  K = 'K',
  V = 'V',
  M = 'M',
  N = 'N',
  B = 'B',
  A = 'A',
}
